"use strict";
// Reusable Stevie Images for tiles
Object.defineProperty(exports, "__esModule", { value: true });
exports.spritesPieces = void 0;
var imageRecycler_sidecar_1 = require("@dive/to-engine/imageRecycler-sidecar");
var crokinoleLayers_sidecar_1 = require("../scene/crokinoleLayers-sidecar");
exports.spritesPieces = imageRecycler_sidecar_1.imageRecycler.create('pieces', function () { return crokinoleLayers_sidecar_1.crokinoleLayers.getLayers().pieces; });
